import { useEffect, useState } from "react";
import api from "@/lib/api";
import { BookOpen } from "lucide-react";

export function DailyVerse() {
  const [v, setV] = useState(null);
  useEffect(() => { api.get("/public/daily-verse").then(({ data }) => setV(data)).catch(() => {}); }, []);
  if (!v) return null;
  return (
    <div className="mx-3 my-3 rounded-lg border border-amber-400/40 bg-amber-500/15 px-4 py-3" data-testid="daily-verse">
      <div className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-amber-200"><BookOpen className="h-3.5 w-3.5" />May God Bless you and your business today</div>
      <p className="mt-2 text-sm leading-relaxed text-amber-50 italic" data-testid="daily-verse-text">“{v.text}”</p>
      <div className="mt-1.5 text-xs text-amber-300/90" data-testid="daily-verse-ref">— {v.reference}{v.version ? ` (${v.version})` : ""}</div>
    </div>
  );
}
